<template>
  <q-layout view="hHh lpR fFf">
    <q-page-container>
      <q-page class="flex flex-center" style="min-height: 100vh; background: linear-gradient(135deg, #4688f5 0%, #ffffffff 100%);">
        <div class="tour-container q-pa-lg">
          <q-card class="tour-card">
            <q-card-section class="text-center q-pt-xl q-pb-md" v-if="step <= maxSteps">
              <img src="@/assets/douranovo.png" alt="DouraSoft Logo" style="width: 180px; height: auto;" />
              
              <div class="q-mt-lg">
                <h5 class="text-h5 text-weight-medium q-ma-none q-mb-xs">
                  {{ getTitleForStep() }}
                </h5>
                <p class="text-grey-7 q-ma-none">
                  Configure seu sistema em poucos passos
                </p>
              </div>

              <!-- Progress Indicator -->
              <div class="q-mt-lg q-px-md">
                <div class="row items-center justify-between q-mb-sm">
                  <span class="text-caption text-grey-7">Progresso</span>
                  <span class="text-caption text-weight-medium text-blue-7">
                    Passo {{ step }} de {{ maxSteps }}
                  </span>
                </div>
                <q-linear-progress 
                  :value="step / maxSteps" 
                  color="blue-7" 
                  rounded
                  size="8px"
                />
              </div>
            </q-card-section>

            <q-card-section class="text-center q-pt-xl" v-else>
              <img src="@/assets/douranovo.png" alt="DouraSoft Logo" style="width: 180px; height: auto;" />
            </q-card-section>

            <!-- Tour Steps Content -->
            <q-card-section class="q-px-xl q-pb-md">
              <transition name="fade" mode="out-in">
                <div :key="step">
                  <tour-inicio v-if="step === 1" />
                  <tour-caixas v-if="caixas" />
                  <tour-fornecedores v-if="step === 2" />
                  <tour-funcionarios v-if="step === 3" />
                  <tour-responsavel v-if="responsavel" />
                  <tour-contas v-if="options.is_loterica && step === 4" />
                  <tour-gateways v-else-if="step === 4" @next="step += 1" />
                  <tour-produtos v-if="options.is_loterica && step === 5" @next="step += 1"/>
                  <tour-logo v-if="(!options.is_loterica && step === 5) || (options.is_loterica && step === 6)" @next="step += 1"/>
                  <tour-video-final v-if="step === (maxSteps + 1)" />
                </div>
              </transition>
            </q-card-section>

            <!-- Navigation -->
            <q-card-section class="q-px-xl q-pb-xl">
              <div class="row q-gutter-sm">
                <q-btn
                  v-if="step > 1 && step <= maxSteps"
                  flat
                  rounded
                  color="blue-7"
                  label="Voltar"
                  @click="step -= 1"
                  class="col"
                  style="text-transform: none; font-weight: 500;"
                  icon="arrow_back"
                />
                
                <q-btn
                  v-if="step <= maxSteps"
                  unelevated
                  rounded
                  color="blue-7"
                  :label="step === 1 ? 'Iniciar Tour' : 'Continuar'"
                  @click="step += 1"
                  :class="step > 1 ? 'col' : 'full-width'"
                  style="text-transform: none; font-weight: 500;"
                  icon-right="arrow_forward"
                />

                <q-btn
                  v-if="step === (maxSteps + 1)"
                  unelevated
                  rounded
                  color="blue-7"
                  label="Finalizar e Começar"
                  @click="videoNext"
                  class="full-width"
                  size="lg"
                  style="text-transform: none; font-weight: 500;"
                  icon-right="check_circle"
                />
              </div>
            </q-card-section>

            <q-separator v-if="step === 1" />

            <q-card-section v-if="step === 1" class="text-center q-py-md">
              <p class="text-body2 text-grey-7 q-ma-none">
                Não deseja fazer o tour agora?
                <span 
                  class="text-blue-7 cursor-pointer" 
                  style="text-decoration: none; font-weight: 500;"
                  @click="$router.push('/visao360')"
                >
                  Pular para o sistema
                </span>
              </p>
            </q-card-section>
          </q-card>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script>
import axios from "@/axios-auth";
import { Notify, createMetaMixin } from "quasar";

export default {
  name: "Tour",
  mixins: [createMetaMixin({ title: "DSB | Tour" })],
  data() {
    return {
      inicio: true,
      caixas: false,
      fornecedores: false,
      funcionarios: false,
      responsavel: false,
      video: false,
      step: 1,
      options: {},
    };
  },
  computed: {
    maxSteps() {
      // Para não-loterica: passos 1,2,3,4,5 (5 passos)
      // Para loterica: passos 1,2,3,4,5,6 (6 passos)
      let maxSteps = 5;
      if (this.options.is_loterica) {
        maxSteps = 6;
      }
      return maxSteps;
    },
  },
  methods: {
    videoNext() {
      axios.get("/users/tour?passo=7").then(res => {
        if (res.data.success) {
          Notify.create({
            message: res.data.message,
            color: "green",
            position: "top-right"
          });
          // vue-router 4 navigations are always asynchronous. Vue Router 3 committed this
          // push synchronously (the target's guard is synchronous), so the reload below
          // happened on /visao360. Now the reload would fire before the URL changes and
          // reload the current page instead — on /configuracao that restarts the polling
          // that got here, in a loop. Reload once the navigation has settled, as before.
          this.$router.push("/visao360").finally(() => this.$router.go(0));
        }
      });
    },
    getOptions() {
      axios.get("/users/tour?passo=1").then(res => {
        if (res.data.success) {
          this.options = res.data.options;
        }
      });
    },
    getTitleForStep() {
      const titles = {
        1: 'Bem-vindo ao DouraSoft!',
        2: 'Cadastro de Fornecedores',
        3: 'Cadastro de Funcionários',
        4: this.options.is_loterica ? 'Configuração de Contas' : 'Configuração de Gateways',
        5: this.options.is_loterica ? 'Cadastro de Produtos' : 'Personalização',
        6: 'Personalização'
      };
      return titles[this.step] || 'Configuração Inicial';
    }
  },
  mounted() {
    this.getOptions();
    this.$store.dispatch("loadManuais");
  },
};
</script>

<style lang="stylus" scoped>
.tour-container
  width 100%
  max-width 700px

.tour-card
  border-radius 16px
  box-shadow 0 10px 40px rgba(0, 0, 0, 0.1)

.q-btn
  transition all 0.3s ease

  &:hover
    transform translateY(-2px)
    box-shadow 0 4px 12px rgba(0, 0, 0, 0.15)

.fade-enter-active, .fade-leave-active
  transition opacity 0.3s ease

// Vue 3 renamed the enter start class: `-enter` is never applied any more.
.fade-enter-from, .fade-leave-to
  opacity 0
</style>